import { render } from "./DetailView.vue?vue&type=template&id=3ee9dd16&scoped=true"
import script from "./DetailView.vue?vue&type=script&lang=ts"
export * from "./DetailView.vue?vue&type=script&lang=ts"

import "./DetailView.vue?vue&type=style&index=0&id=3ee9dd16&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-3ee9dd16"

export default script